module.exports = __webpack_public_path__ + "media/images/partners/fukuoka-fa036b34727976dcd496855e40d6b2bf.png";